const Viento = {
  N: "Norte",
  NNE: "Nornoreste",
  NE: "Norte-Este-Noreste",
  ENE: "Estenoreste",
  E: "Este",
  ESE: "Estesudeste o Estesureste",
  SE: "Sur-Este-Sudeste o Sureste",
  SSE: "Sursudeste o Sursureste",
  S: "Sur",
  SSO: "Sursudoeste o Sursuroeste",
  SSW: "Sursudoeste o Sursuroeste",
  SO: "Sur-Oeste-Sudoeste/Suroeste",
  SW: "Sur-Oeste-Sudoeste/Suroeste",
  OSO: "Oestesudoeste o Oestesuroeste",
  WSW: "Oestesudoeste o Oestesuroeste",
  O: "Oeste",
  W: "Oeste",
  ONO: "Oestenoroeste",
  WNW: "Oestenoroeste",
  NO: "Norte-Oeste-Noroeste",
  NW: "Norte-Oeste-Noroeste",
  NNO: "Nornoroeste",
  NNW: "Nornoroeste",
};
/*
const Viento = (e) => {
  let dir = "vacio";
  switch (e) {
    case "N":
      dir = "Norte";
      break;
    case "NNE":
      dir = "Nornoreste";
      break;
    case "NE":
      dir = "Norte-Este-Noreste";
      break;
    case "ENE":
      dir = "Estenoreste";
      break;
    case "E":
      dir = "Este";
      break;
    case "ESE":
      dir = "Estesudeste o Estesureste";
      break;
    case "SE":
      dir = "Sur-Este-Sudeste o Sureste";
      break;
    case "SSE":
      dir = "Sursudeste o Sursureste";
      break;
    case "S":
      dir = "Sur";
      break;
    case "SSO":
      dir = "Sursudoeste o Sursuroeste";
      break;
    case "SSW":
      dir = "Sursudoeste o Sursuroeste";
      break;
    case "SO":
      dir = "Sur-Oeste-Sudoeste/Suroeste";
      break;
    case "SW":
      dir = "Sur-Oeste-Sudoeste/Suroeste";
      break;
    case "OSO":
      dir = "Oestesudoeste o Oestesuroeste";
      break;
    case "WSW":
      dir = "Oestesudoeste o Oestesuroeste";
      break;
    case "O":
      dir = "Oeste";
      break;
    case "W":
      dir = "Oeste";
      break;
    case "ONO":
      dir = "Oestenoroeste";
      break;
    case "WNW":
      dir = "Oestenoroeste";
      break;
    case "NO":
      dir = "Norte-Oeste-Noroeste";
      break;
    case "NW":
      dir = "Norte-Oeste-Noroeste";
      break;
    case "NNO":
      dir = "Nornoroeste";
      break;
    case "NNW":
      dir = "Nornoroeste";
      break;
    default:
      break;
  }
  return dir;
};
*/
export default Viento;
